export const OrderStatus = ({ order }: { order: any }) => {
  // 예약판매
  if (order?.packId) {
    if (order?.isPackConfirmed === true) {
      return <span className="text-green-600">주문 확정</span>;
    } else if (order?.isPackConfirmed === false && order?.isCanceled === true) {
      return <span className="text-red-600">주문 취소</span>;
    } else if (
      order?.isPackConfirmed === false &&
      order?.isCanceled === false
    ) {
      return <span className="text-blue-600">주문 확정전</span>;
    }
  }
  // 실시간판매
  else {
    if (order?.isCanceled === false) {
      return <span className="text-green-600">주문 확정</span>;
    } else {
      return <span className="text-red-600">주문 취소</span>;
    }
  }

  return null;
};
